import { getUrl } from '../utils/getUrl';
import { headers } from './account';

export const searchEntries = (term: string, handle?: string, page?: number) => {
  const handlePath = handle ? `${handle}` : `entries`;
  const pageParam = !page ? '' : `?page=${page}`;
  return fetch(
    `${getUrl()}/api/${handlePath}/search/${encodeURI(term)}${pageParam}`,
    {
      headers,
    }
  ).then((res) => res.json());
};

export const searchStages = (term: string, page?: number) => {
  const pageParam = !page ? '' : `?page=${page}`;
  return fetch(
    `${getUrl()}/api/account/search/${encodeURI(term)}${pageParam}`,
    {
      headers,
    }
  ).then((res) => res.json());
};
